<template>
  <div v-observe-visibility="visibilityOptions">
    <a-vue-disqus v-if="isLazyLoaded" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import {
  OBSERVER_CALLBACK_DEFAULT_THROTTLE,
  OBSERVER_DEFAULT_ROOT_MARGIN
} from 'enums/mutation-observer'

export default {
  name: 'AVueDisqusLazyLoad',
  components: {
    AVueDisqus: () => import('./index')
  },
  data() {
    return {
      isLazyLoaded: false,
      visibilityOptions: {
        callback: this.loadComponent,
        throttle: OBSERVER_CALLBACK_DEFAULT_THROTTLE,
        once: true,
        intersection: {
          rootMargin: OBSERVER_DEFAULT_ROOT_MARGIN
        }
      }
    }
  },
  methods: {
    loadComponent(isVisible) {
      if (!isVisible) return

      this.isLazyLoaded = true
    }
  }
}
</script>
